import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInfoMulticolored$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfoMulticolored extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6d3a6b788c226723fae5871aec2dc2584ffb603f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5ca93d317483bf9bf9c8b7dbde83f2dd74d141b6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ae318b93ee7cb8e5ad2c431407caaa6e1c55544a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9", fill: "currentColor", "fill-opacity": ".2" }), h("path", { key: '2d25722904ce44de3f407c71f6a5bda6d09cd4d5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.25 8.56a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-3 2.44v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4h-2a.5.5 0 0 1-.5-.5", fill: "currentColor", "fill-opacity": ".6" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-info-multicolored", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-info-multicolored"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-info-multicolored":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfoMulticolored$1);
            }
            break;
    } });
}

const CosmosIconInfoMulticolored = CosmosIconInfoMulticolored$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfoMulticolored, defineCustomElement };
